"use client";

import { useRouter } from "next/navigation";
import { useSession } from "../lib/SessionProvider";
import { useEffect, useState } from "react";
import { usePostHog } from "posthog-js/react";
import dynamic from "next/dynamic";
const LoginForm = dynamic(() => import('../components/LoginForm'), {
  ssr: false,
})


export default function HomePage() {
  const { isLoggedIn, login, user } = useSession();
  const [isClient, setIsClient] = useState(false);
  const router = useRouter();
  const posthog = usePostHog()


  useEffect(() => {
    setIsClient(true);
  }, []);


  useEffect(() => {
    if (isClient) {
      if (isLoggedIn) {
        posthog.identify(user?.email);
        router.push("/dashboard");
      } else {
        router.push("/login");
      }
    }
  }, [isClient, isLoggedIn, router, user, posthog]);

  if (isLoggedIn) {
    return null;
  }

  return (
    <>
      {isClient ? <LoginForm onLogin={(token, user) => login(token, user)} /> : null}
    </>
  );
}
